module.exports = __webpack_public_path__ + "200336b2a998a59672e40452990afbb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/pro-era.jpg
// module id = 496
// module chunks = 0